import _Popup from './Popup';

import './style';

export type { PopupProps } from './Popup';
export const Popup = _Popup;

export default Popup;
